//HTTPステータス
export const OK                     =   200
export const CREATED                =   201
export const INTERNAL_SERVER_ERROR  =   500
export const UNAUTHORIXED           =   401
export const BAD_REAUEST            =   400

export const LoginMsg       =   "ログイン認証中..."
export const LogoutMsg      =   "ログアウト中..."
export const RegisterMsg    =   "ユーザー作成中..."
export const ServerLoading  =   "サーバー通信中..."

//ステータス
export const STATUS_UNSUPPORTED   =   {key: 1, value: '未対応'}
export const STATUS_IS_SUPPORTED  =   {key: 2, value: '対応中'}
export const STATUS_FIXED         =   {key: 3, value: '対応済'}
export const STATUS_CONVERGENCE   =   {key: 4, value: '輻輳(対応済)'}
export const STATUS_COMPLETED     =   {key: 5, value: '完了(対応済)'}

export const STATUSES = [STATUS_UNSUPPORTED, STATUS_IS_SUPPORTED, STATUS_FIXED, STATUS_CONVERGENCE, STATUS_COMPLETED]

import L from 'leaflet'

export const T_STD = new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
  attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
})
export const T_PALE = new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png', {
  attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
})
export const O_STD = new L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
})
export const BASEGIS = new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg', {
  attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
})

export const TASK_STATUS = [
  { id: 1, dispname: "未対応"},
  { id: 2, dispname: "対応中"},
  { id: 3, dispname: "対応済"},
  { id: 4, dispname: "輻輳(対応済)"},
  { id: 5, dispname: "完了(対応済)"}
]